import type { ComponentChildren } from 'preact';

// Stylised iPhone-ish frame. Renders whatever you pass as children at
// roughly device aspect ratio. Pure CSS, no real PNG bezel.

type Props = {
  children: ComponentChildren;
  width?: number;
  rotate?: number;
};

export function PhoneFrame({ children, width = 280, rotate = 0 }: Props) {
  const height = Math.round(width * (874 / 402)); // matches design device size
  return (
    <div
      style={{
        width: `${width}px`,
        height: `${height}px`,
        transform: `rotate(${rotate}deg)`,
        borderRadius: 44,
        padding: 8,
        background: 'linear-gradient(160deg, #1f1814 0%, #3a2d22 100%)',
        boxShadow:
          '0 24px 60px rgba(31,24,20,0.28), 0 0 0 1px rgba(255,255,255,0.04) inset',
      }}
    >
      <div
        style={{
          width: '100%',
          height: '100%',
          borderRadius: 36,
          overflow: 'hidden',
          background: 'var(--cream-2)',
          position: 'relative',
        }}
      >
        {children}
      </div>
    </div>
  );
}
